import { useMemo } from 'react';
import useImageWithFallback, {
  type ImageMap
} from '~/hooks/common/ui/useImageWithFallback';

type ImageType = 'still';

export default function useWhyBuyStillImage(
  imageUrl: string | undefined,
  location: string
): string | undefined {
  const images = useMemo<ImageMap<ImageType> | undefined>(
    () =>
      imageUrl ? { still: { imageType: 'still', url: imageUrl } } : undefined,
    [imageUrl]
  );

  return useImageWithFallback(images, imageUrl ? 'still' : undefined, location)
    ?.url;
}
